import PageHeader from '../../components/shared/PageHeader';

// Shared shell for the static legal pages.
export default function LegalLayout({ title, subtitle, updated, children }) {
  return (
    <div className="animate-fade-in">
      <PageHeader title={title} subtitle={subtitle} backTo="/settings" />
      <div className="px-5 py-4 pb-10" style={{ maxWidth: 430 }}>
        {updated && (
          <p className="text-[11px] mb-4" style={{ color: 'var(--text-3)' }}>Last updated: {updated}</p>
        )}
        <div className="legal-body" style={{ fontSize: 13, lineHeight: 1.7, color: 'var(--text-2)' }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section style={{ marginBottom: 18 }}>
      <h2 className="font-head" style={{ fontSize: 14, fontWeight: 700, color: 'var(--navy)', margin: '0 0 6px' }}>
        {heading}
      </h2>
      {children}
    </section>
  );
}
